<template>
  <div v-if="mx_breadcrumb"
       class="portal-content--bread-crumbs bread-crumbs d-flex align-items-center">
    <b-button class="crumb" variant="link" :to="mx_breadcrumbUrl">
      <font-awesome-icon
        class="mr-2"
        :icon="['far', 'arrow-left']"
      />{{ mx_breadcrumb.text }}
    </b-button>
  </div>
</template>
<script>
import { ifacBreadcrumbMixin } from '@ifac/ui';

export default {
  name: 'PortalBreadcrumb',
  mixins: [ifacBreadcrumbMixin],
};
</script>
